/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FileUploadRes } from '../models/file-upload-res';

@Injectable({
  providedIn: 'root',
})
export class FileApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiFilePost
   */
  static readonly ApiFilePostPath = '/api/file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFilePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilePost$Response(params?: {
  }): Observable<StrictHttpResponse<FileUploadRes>> {

    const rb = new RequestBuilder(this.rootUrl, FileApiService.ApiFilePostPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileUploadRes>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiFilePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFilePost(params?: {
  }): Observable<FileUploadRes> {

    return this.apiFilePost$Response(params).pipe(
      map((r: StrictHttpResponse<FileUploadRes>) => r.body as FileUploadRes)
    );
  }

}
